"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var marginStyles = function marginStyles() {
  var result = '';
  Object.keys(_tokens.spacing.vertical).forEach(function (item) {
    if (item !== "none") {
      result += "\n      .pb-".concat(item, "{\n        padding-bottom: ").concat(_tokens.spacing.vertical[item] === 'auto' ? 'auto' : _tokens.spacing.vertical[item] + "px", ";\n      }\n      .pt-").concat(item, "{\n        padding-top: ").concat(_tokens.spacing.vertical[item] === 'auto' ? 'auto' : _tokens.spacing.vertical[item] + "px", ";\n      }\n      .py-").concat(item, "{\n        padding-top: ").concat(_tokens.spacing.vertical[item] === 'auto' ? 'auto' : _tokens.spacing.vertical[item] + "px", ";\n        padding-bottom: ").concat(_tokens.spacing.vertical[item] === 'auto' ? 'auto' : _tokens.spacing.vertical[item] + "px", ";\n      }\n      ");
    }
  });
  Object.keys(_tokens.spacing.horizontal).forEach(function (item) {
    if (item !== "none") {
      result += "\n      .pl-".concat(item, "{\n        padding-left: ").concat(_tokens.spacing.horizontal[item] === 'auto' ? 'auto' : _tokens.spacing.horizontal[item] + "px", ";\n      }\n      .pr-").concat(item, "{\n        padding-right: ").concat(_tokens.spacing.horizontal[item] === 'auto' ? 'auto' : _tokens.spacing.horizontal[item] + "px", ";\n      }\n      .px-").concat(item, "{\n        padding-right: ").concat(_tokens.spacing.horizontal[item] === 'auto' ? 'auto' : _tokens.spacing.horizontal[item] + "px", ";\n        padding-left: ").concat(_tokens.spacing.horizontal[item] === 'auto' ? 'auto' : _tokens.spacing.horizontal[item] + "px", ";\n      }\n      ");
    }
  });
  return result;
};

var _default = marginStyles;
exports.default = _default;